module.exports = __webpack_public_path__ + "static/bg_mobile-f48858a80f9fe463d5f5547c76d4413f.png";